// extracted by mini-css-extract-plugin
export default {"desktopContainer":"HeaderLanding_desktopContainer__5sIzl","mobileContainer":"HeaderLanding_mobileContainer__dxMB1"};